import React from 'react'

import {typeDataStatisticsRowActions} from './index';
import {DashboardContentPage} from '../DashboardContentTable';

import {Daily} from './charts/Daily/Daily'
import {DataPageDashboard} from '../DashboardContentTable/DataPageDashboard'
import {DateFilter} from './charts/DateFilter/DateFilter'
import {TabPanel} from './charts/TabPanel'
import {BarChart, typeData} from 'components/UI/BarChart/BarChart'
import {RadialChart} from 'components/UI/RadialChart/RadialChart'
import {
    typeEmployeeTableItem,
    typePeriod,
    typeProductFullItem,
} from 'model/dashboardStatistics/dStatisticsReducer'
import {Loader} from 'components/UI/Loader/Loader'
import {Alert} from 'components/UI/Alert/Alert'
import {Trans} from "@lingui/macro";



// Type
export type typeViewDataStatistics = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
    rowsActions?: typeDataStatisticsRowActions
    period?: typePeriod

    loaderDaily: boolean
    loaderFilter: boolean

    stringPeriod: string

    hoursStatistic: typeData | null
    weekDayStatistic: typeData | null
    paymentMethodAmountStatistic: typeData | null
    paymentMethodCountStatistic: typeData | null
    saleTypeAmountStatistic: typeData | null
    saleTypeCountStatistic: typeData | null
    employeeStatistic:  typeEmployeeTableItem[] | null
    productStatistic:  typeProductFullItem[] | null
}


// Component
export const ViewDataStatistics: React.FC<typeViewDataStatistics> = ({
    setSidebarOpen,
    stringPeriod,

    loaderFilter,
    loaderDaily,

    hoursStatistic,
    weekDayStatistic,
    paymentMethodAmountStatistic,
    paymentMethodCountStatistic,
    saleTypeAmountStatistic,
    saleTypeCountStatistic,
    employeeStatistic,
    productStatistic,
}) => {

    const periodComponent = <span className="text-xs text-gray-600">{stringPeriod}</span>

    return (
            <DashboardContentPage
                headerTitle={<Trans>Statistics</Trans>}
                setSidebarOpen={setSidebarOpen}
            >

                <DataPageDashboard>

                    <div className="flex flex-col gap-y-10">

                        <Daily/>

                        <DateFilter/>

                        <div className="flex flex-col gap-4">
                            <div className="flex justify-between gap-4">
                                <div className="col-span-2 text-xl font-semibold text-gray-900">
                                    <Trans>Sales amount</Trans> {periodComponent}
                                </div>
                            </div>
                            <div>
                                <TabPanel/>
                            </div>
                        </div>

                        <div className="relative grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-4 sm:gap-x-10">

                            <div className="col-span-2 text-xl font-semibold text-gray-900">
                                <Trans>Payment methods</Trans> {periodComponent}
                            </div>
                            <div className="col-span-2 text-xl font-semibold text-gray-900">
                                <Trans>Payment types</Trans> {periodComponent}
                            </div>

                            <div className="flex flex-col justify-center">
                                <span className="pb-2 text-gray-600 text-center">
                                    <Trans>Sales amount</Trans>
                                </span>
                                <span className="flex flex-col justify-center pb-2">
                                    {paymentMethodAmountStatistic && paymentMethodAmountStatistic.labels.length !== 0
                                        ? <RadialChart amountTitle={<Trans>Payment method amount</Trans>} data={paymentMethodAmountStatistic}/>
                                        : <div className="flex justify-center"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></div>
                                    }
                                </span>
                            </div>

                            <div className="flex flex-col justify-center">
                                <span className="pb-2 text-gray-600 text-center">
                                    <Trans>Checks count</Trans>
                                </span>
                                <span className="flex flex-col justify-center pb-2">
                                    {paymentMethodCountStatistic && paymentMethodCountStatistic.labels.length !== 0
                                        ? <RadialChart amountTitle={<Trans>Payment method amount</Trans>} data={paymentMethodCountStatistic}/>
                                        : <div className="flex justify-center"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></div>
                                    }
                                </span>
                            </div>

                            <div className="flex flex-col justify-center">
                                <span className="pb-2 text-gray-600 text-center">
                                    <Trans>Sales amount</Trans>
                                </span>
                                <span className="flex flex-col justify-center pb-2">
                                    {saleTypeAmountStatistic && saleTypeAmountStatistic.labels.length !== 0
                                        ? <RadialChart amountTitle={<Trans>Sale type amount</Trans>} data={saleTypeAmountStatistic}/>
                                        : <div className="flex justify-center"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></div>
                                    }
                                </span>
                            </div>

                            <div className="flex flex-col justify-center">
                                <span className="pb-2 text-gray-600 text-center">
                                    <Trans>Checks count</Trans>
                                </span>
                                <span className="flex flex-col justify-center pb-2">
                                    {saleTypeCountStatistic && saleTypeCountStatistic.labels.length !== 0
                                        ? <RadialChart amountTitle={<Trans>Sale type amount</Trans>} data={saleTypeCountStatistic}/>
                                        : <div className="flex justify-center"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></div>
                                    }
                                </span>
                            </div>

                            {/*
                            <div className="flex flex-col justify-center">
                                <span className="flex justify-center">
                                    <Link
                                        className="flex justify-center items-center py-1 px-2 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        to={ROUTS.STATISTICS_PAYMENT_METHODS_DASHBOARD}
                                    >
                                        <Trans>More</Trans>
                                    </Link>
                                </span>
                            </div>

                            <div className="flex flex-col justify-center">
                                <span className="flex justify-center">
                                    <Link
                                        className="flex justify-center items-center py-1 px-2 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        to={ROUTS.STATISTICS_PAYMENT_METHODS_DASHBOARD}
                                    >
                                        <Trans>More</Trans>
                                    </Link>
                                </span>
                            </div>

                            <div className="flex flex-col justify-center">
                                <span className="flex justify-center">
                                    <Link
                                        className="flex justify-center items-center py-1 px-2 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        to={ROUTS.STATISTICS_PAYMENT_TYPES_DASHBOARD}
                                    >
                                        <Trans>More</Trans>
                                    </Link>
                                </span>
                            </div>
                            */}

                            {loaderFilter || loaderDaily ? <Loader/> : null}

                        </div>


                        <div className="relative flex flex-col gap-4">

                            <div className="flex justify-between gap-4">
                                <div className="col-span-2 text-xl font-semibold text-gray-900">
                                    <Trans>Statistics by hours and days of the week</Trans> {periodComponent}
                                </div>
                                {/*
                                <Link
                                    className="flex justify-center items-center py-1 px-2 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    to={ROUTS.STATISTICS_DAILY_DASHBOARD}
                                >
                                    <Trans>More</Trans>
                                </Link>
                                */}
                            </div>
                            <div className="grid grid-cols-3 gap-y-4 gap-x-10">

                                <div className="col-span-2">
                                    <div className="flex flex-col justify-center">
                                        <span className="flex flex-col justify-center h-72">
                                            {hoursStatistic && hoursStatistic.labels.length !==0
                                                ? <BarChart data={hoursStatistic} legend={false}/>
                                                : <div className="flex justify-center"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></div>
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex flex-col justify-center">
                                        <span className="flex flex-col justify-center h-72">
                                            {weekDayStatistic && weekDayStatistic.labels.length !==0
                                                ? <BarChart data={weekDayStatistic} legend={false}/>
                                                : <div className="flex justify-center"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></div>
                                            }
                                        </span>
                                    </div>
                                </div>

                            </div>

                            {loaderFilter || loaderDaily ? <Loader/> : null}

                        </div>

                        <div className="relative flex flex-col gap-4">

                            <div className="flex justify-between gap-4">

                                <div className="col-span-2 text-xl font-semibold text-gray-900">
                                    <Trans>Top employees statistics</Trans> {periodComponent}
                                </div>
                                {/*
                                <Link
                                    className="flex justify-center items-center py-1 px-2 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    to={ROUTS.STATISTICS_EMPLOYEE_DASHBOARD}
                                >
                                    <Trans>More</Trans>
                                </Link>
*/}
                            </div>

                            <div>
                                <div className="flex flex-col">
                                    <div className="-my-2 overflow-x-auto">
                                        <div className="py-2 align-middle inline-block min-w-full">
                                            <div
                                                className="overflow-hidden border border-gray-200 shadow-sm sm:rounded-lg">
                                                <table className="min-w-full">
                                                    <thead className="bg-primary-700">
                                                        <tr className="relative">
                                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                                                                &nbsp;
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Employee</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Sales amount</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Count of sales</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Average check</Trans>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y">
                                                        {employeeStatistic
                                                            ? employeeStatistic.map((item, index) => <tr key={index} className="bg-white hover:bg-primary-50">
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                    {index + 1}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 ">
                                                                    {item.name}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                    {item.amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                    {item.count}
                                                                </td>
                                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                    {item.average.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                </td>
                                                            </tr>)
                                                            // @ts-ignore
                                                            : <tr><td colSpan="5"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></td></tr>
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {loaderFilter || loaderDaily ? <Loader/> : null}

                        </div>



                        <div className="relative flex flex-col gap-4">

                            <div className="flex justify-between gap-4">

                                <div className="col-span-2 text-xl font-semibold text-gray-900">
                                    <Trans>Top sale products</Trans> {periodComponent}
                                </div>

                                {/*
                                <Link
                                    className="flex justify-center items-center py-1 px-2 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    to={ROUTS.STATISTICS_PRODUCT_DASHBOARD}
                                >
                                    <Trans>More</Trans>
                                </Link>
                                */}

                            </div>

                            <div>
                                <div className="flex flex-col">
                                    <div className="-my-2 overflow-x-auto">
                                        <div className="align-middle inline-block min-w-full">
                                            <div className="overflow-hidden border border-gray-200 shadow-sm sm:rounded-lg">
                                                <table className="min-w-full">
                                                    <thead className="bg-primary-600">
                                                        <tr className="relative">
                                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                                                                &nbsp;
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Name</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Sales amount</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Count of sales</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Average check</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Refunds amount</Trans>
                                                            </th>
                                                            <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                                                                <Trans>Count of refunds</Trans>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y">
                                                    {productStatistic?.length
                                                        ? productStatistic.map((item, index) => <tr key={index} className="bg-white hover:bg-primary-50">
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {index + 1}
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                                                                {item.name}
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {item.saleTotalAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {item.saleCount}
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {item.saleAverageAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {item.refundTotalAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                            </td>
                                                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {item.refundCount}
                                                            </td>
                                                        </tr>)
                                                        // @ts-ignore
                                                        : <tr><td colSpan="7" className="p-2"><Alert type="info" title={<Trans>No data. Change the period.</Trans>}/></td></tr>
                                                    }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {loaderFilter || loaderDaily ? <Loader/> : null}

                        </div>

                    </div>

                </DataPageDashboard>

            </DashboardContentPage>
    )
}
